import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Collapse,
  Row,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import NumberFormat from "react-number-format";
import AddPartyModel from "../../../RealEstate/Party/PartyForm/PartyForm";
import AddSociety from "../../Society/components/addSociety";
import { Modal } from "react-bootstrap";
import AddSector from "../../Sector/components/addSector";
import Select from "react-select";
import tooltipText from "./../../../../../views/Forms/ShortCutComponents/tooltipText";
import { CheckClosingYearD } from "../../../ShortFunction/CheckClosingYearD";
import moment from "moment";
import { checkPermission } from "../../../../../Helper";
import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { AppSwitch } from "@coreui/react";
import { baseurl } from "./../../../../../baseurl";
import { Link } from "react-router-dom";
import InstallmentFeature from "../../../RealEstate/BuyBackForm/installmentFeature"
import axios from "axios";
import { GetIp } from "./../../../../../views/Forms/ShortCutComponents/Get_ip";
import ReactDatePicker from "./../../../../../views/Forms/ShortCutComponents/ReactDatePicker";
import ResponseLoader from "./../../../../../views/Forms/ShortCutComponents/ResponseLoader";
import { dynamicCurrencyFormator } from "./../../../../../utils/functions";
import PropFeature from "../../DealForm/PropFeaturesModel";

const username = localStorage.getItem("username");
const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");

function addMonths(date, months) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
}

function formatDate(date) {
  return date;
}

export default function DealForm(props) {
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [installmentWizard, setInstallmentWizard] = useState(null);
  const [installmentWizardOption, setInstallmentWizardOption] = useState([]);
  const [mainInstallmentArray, setMainInstallmentArray] = useState([]);
  const [disabledState, setDisabledState] = useState(false);
  const [propTypLov, setPropTypLov] = useState([]);
  const [propSizeLov, setPropSizeLov] = useState([]);
  const [sectorLov, setSectorLov] = useState([]);
  const [partyLov, setPartyLov] = useState([]);
  const [termsTypeLov, setTermsTypeLov] = useState([]);
  const [periodsLov, setPeriodsLov] = useState([]);
  const [societyLov, setSocietyLov] = useState([]);
  const [categoryLov, setCategoryLov] = useState([]);
  const [isOpenInstallmentModal, setIsOpenInstallmentModal] = useState(false);
  const [view, setView] = useState(false);


  // ye state detail form kcolapse ko handle kr rhi hr
  const [divcontainer, setDivcontainer] = useState(true);
  const [divcontainer2, setDivcontainer2] = useState(true);
  const [divcontainer3, setDivcontainer3] = useState(true);
  // ye state LOV k check ko handle kr rhi he
  const [requiredCheck, setRequiredCheck] = useState(false);
  // ye state index save krne k lie he
  const [checkIndex, setCheckIndex] = useState();
  const [ipCountry, setIpCountry] = useState(false);

  const [masterData, setMasterData] = useState({
    purchaseNo: null,
    purchaseDate: new Date(),
    // targetDate: "",
    partyName: "",
    isOpenPartyModel: false,
    isOpenSocietyModel: false,
    isOpenSectorModel: false,
    purchaseDescription: "",
    societyId: "",
    sectorId: "",
    ownerName: "",
    ownerAddress: "",
    ownerPhone: null,
    ownerNic: null,
    // midManId: "",
    remarks: "",
  });
  const [totalValues, setTotalValues] = useState({
    totalComPrice: 0,
    totalCommission: 0,
    totalCost: 0,
  });

  const [data, setData] = useState({
    formValues: [
      {
        lineNum: 1,
        unitNo: "",
        type: "",
        category: "",
        size: "",
        companyPrice: 0,
        commission: 0,
        totalCost: 0,
        isOpenPropModel: false,
      },
    ],
  });
  const [terms, setTerms] = useState({
    formValues: [
      {
        lineNum: 1,
        termsType: null,
        termsAmount: 0,
        termsPersent: null,
        termsPeriod: null,
        termsNo: null,
        termsRemarks: "",
      },
    ],
  });
  const [commission, setCommission] = useState({
    formValues: [
      {
        lineNum: 1,
        commissionParty: null,
        commissionAmount: 0,
        commissionPersent: null,
        commissionRemarks: "",
      },
    ],
  });
  const addPropInstall = (viewValue) => {
    setIsOpenInstallmentModal(prev => !prev);
    setView(viewValue);
  };

  const showProp = (element, index) => {
    setCheckIndex(index);
    addPropToggle();
  };
  const addPropToggle = () => {
    setData({
      ...data,
      isOpenPropModel: !data.isOpenPropModel,
    });
  };
  const stringToNumber = (str) => {
    let newValue = 0;
    if (str) {
      newValue = Number(str?.toString()?.replaceAll(",", ""));
    }

    return newValue;
  };
  const convertToYmdDateFormart = (propDate, useNewDate) => {
    let newDate = null;
    if (propDate) {
      if (useNewDate) {
        newDate = new Date(propDate);
      } else {
        newDate = moment(propDate).format("YYYY-MM-DD");
      }
    }
    return newDate;
  };
  const reCalculate = (formValues) => {
    let totalComPrice = 0;
    let totalCommission = 0;
    let totalCost = 0;
    for (let loop = 0; loop < formValues.length; loop++) {
      const element = formValues[loop];
      totalComPrice += stringToNumber(element.companyPrice);
      totalCommission += stringToNumber(element.commission);
      totalCost += stringToNumber(element.totalCost);
    }
    setTotalValues({
      ...totalValues,
      totalComPrice,
      totalCommission,
      totalCost,
    });
  };
  const emptycommission = () => {
    let formValues = data.formValues;

    let totalCost = 0;
    for (let index = 0; index < formValues.length; index++) {
      const element = formValues[index];
      let commission = element.commission;
      element.totalCost =
        stringToNumber(element.totalCost) - stringToNumber(commission);
      element.commission = 0;
      totalCost += stringToNumber(element.totalCost);
    }

    setData({
      ...data,
      formValues,
    });
    setTotalValues({
      ...totalValues,
      totalCommission: 0,
      totalCost,
    });
  };
  const handleCheckBoxes = (e, rowIndex) => {
    let formValues = data.formValues;
    const { checkboxes, remarks } = e;

    formValues[rowIndex].checkboxes = checkboxes;
    formValues[rowIndex].remarks = remarks;
    setData({
      ...data,
      formValues,
    });
  };
  const checkNullObject = (objId, objLabel) => {
    return objId ? { id: objId, label: objLabel } : null;
  };
  const removeFormFieldsItem = (i) => {
    let formValues = data.formValues;

    if (formValues.length > 1) {
      formValues.splice(i, 1);
      reCalculate(formValues);
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  };
  const removeItemFormFields = (i) => {
    let formValues = terms.formValues;

    if (formValues.length > 1) {
      formValues.splice(i, 1);
      // reCalculate(formValues);
      setTerms({
        ...terms,
        formValues: formValues,
      });
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  };

  const removeAllTerms = () => {
    swal({
      title: "Are you sure?",
      text: "This will remove all terms rows!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setTerms({
          ...terms,
          formValues: [
            {
              lineNum: 1,
              termsType: null,
              termsAmount: 0,
              termsPersent: null,
              termsPeriod: null,
              termsNo: null,
              termsRemarks: "",
            },
          ],
        });
      }
    });
  };
  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    props.history.push({
      pathname: "/DealPrint",
      state1: masterData,
      state2: data,
      // state3: totalValues,
    });
  };
  const removeFormFieldsItem2 = (i) => {
    let formValues = commission.formValues;
    let dynamicMsg = "Your Commission data is completely removed!";

    if (formValues.length > 1) {
      formValues.splice(i, 1);

      setCommission({
        ...commission,
        formValues,
      });
    } else {
      formValues[0]["partner"] = null;
      formValues[0]["lineNum"] = 1;
      formValues[0]["percentage"] = 0;
      formValues[0]["pRemarks"] = "";

      setCommission({ ...commission, formValues });
      swal({
        title: "No Commission!",
        text: dynamicMsg,
        icon: "warning",
      });
    }
  };
  const addTermsFormFields = () => {
    let lineNumber = terms.formValues.length + 1;
    console.log("lineNumber--------------", lineNumber);

    setTerms({
      formValues: [
        ...terms.formValues,
        {
          partyLov: null,
          percentage: 0,
          pRemarks: "",

          lineNum: lineNumber,
        },
      ],
      show: false,
    });
  };
  const addFormFieldsItem2 = () => {
    let lineNumber = commission.formValues.length + 1;
    console.log("lineNumber=========", lineNumber);

    setCommission({
      formValues: [
        ...commission.formValues,
        {
          partyLov: null,
          percentage: 0,
          pRemarks: "",

          lineNum: lineNumber,
        },
      ],
      show: false,
    });
  };
  const addFormFieldsItem = (copyWithRecord, index) => {
    let lineNumber = data.formValues.length + 1;
    let formValues;

    if (copyWithRecord) {
      let rowData = data.formValues[index];
      formValues = [
        ...data.formValues,
        {
          unitNo: rowData.unitNo,
          type: rowData.type,
          category: rowData.category,
          size: rowData.size,
          companyPrice: rowData.companyPrice,
          commission: rowData.commission,
          totalCost: rowData.totalCost,
          lineNum: lineNumber,
        },
      ];
      setData({
        formValues,
        show: false,
      });
      reCalculate(formValues);
    } else {
      setData({
        formValues: [
          ...data.formValues,
          {
            lineNum: lineNumber,
          },
        ],
        show: false,
      });
    }
  };
  const masterInputEvent = (e, pName) => {
    if (pName === "partyName") {
      setMasterData({ ...masterData, partyName: e });
    } else if (pName === "societyId") {
      if (e?.id) {
        propSectLov(e.id);
        setMasterData({ ...masterData, societyId: e, sectorId: null });
      } else {
        setMasterData({ ...masterData, sectorId: null, societyId: null });
        setSectorLov({
          sectorOptions: [],
        });
      }
    } else if (pName === "sectorId") {
      setMasterData({ ...masterData, sectorId: e });
    } else if (pName === "midManId") {
      setMasterData({ ...masterData, midManId: e });
      if (e === null) emptycommission();
    } else {
      const value = e.target.value;
      const name = e.target.name;

      setMasterData({ ...masterData, [name]: value });
      console.log("======================", name, value);
    }
  };
  const masterInputEvent2 = (index, e, pName) => {
    let formValues = commission.formValues;
    if (pName === "partner") {
      formValues[index][pName] = e;
      setCommission({
        ...commission,
        formValues,
      });
    } else if (e.target.name === "percentage") {
      formValues[index]["percentage"] = e.target.value;
      let totalPercentage = formValues.reduce(
        (acc, element) => acc + Number(element.percentage),
        0,
      );

      if (Number(totalPercentage) <= 100) {
        formValues[index]["percentage"] = e.target.value;
        setCommission({
          ...commission,
          formValues,
        });
      } else {
        swal({
          title: "Invalid",
          text: "Percentage cannot be more than 100",
          icon: "warning",
        });
        formValues[index]["percentage"] = 0;
        setCommission({
          ...commission,
          formValues,
        });
      }
    } else if (e.target.name === "pRemarks") {
      formValues[index]["pRemarks"] = e.target.value;
      setCommission({
        ...commission,
        formValues,
      });
    }
  };
  const inputEvent = (e, index, pName) => {
    let formValues = data.formValues;

    if (pName) {
      if (pName === "type") {
        formValues[index]["type"] = e;
      } else if (pName === "size") {
        formValues[index]["size"] = e;
      } else if (pName === "category") {
        formValues[index]["category"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;

      if (name === "unitNo") {
        formValues[index]["unitNo"] = value;
      } else if (name === "companyPrice") {
        formValues[index]["companyPrice"] = value;

        formValues[index]["totalCost"] =
          stringToNumber(value) +
          stringToNumber(formValues[index]["commission"]);
      } else if (name === "commission") {
        formValues[index]["commission"] = value;
        formValues[index]["totalCost"] =
          stringToNumber(value) +
          stringToNumber(formValues[index]["companyPrice"]);
      } else if (name === "totalCost") {
        formValues[index]["totalCost"] = value;
      }
      if (
        name === "companyPrice" ||
        name === "commission" ||
        name === "totalCost"
      ) {
        reCalculate(formValues);
      }
    }
    setData({
      ...data,
      formValues,
    });
  };
  const inputEvent2 = (e, index, pName) => {
    let formValues = terms.formValues;

    if (pName) {
      console.log(e);
      if (pName === "termsType") {
        formValues[index]["termsType"] = e;
      } else if (pName === "termsPeriod") {
        formValues[index]["termsPeriod"] = e;
      } else if (pName === "paymentDate") {
        formValues[index]["paymentDate"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log("--------------------=", name, value);
      let totalnet = totalValues.totalCost?.toString()?.replaceAll(",", "");
      totalnet = parseFloat(totalnet) > 0 ? parseFloat(totalnet) : 0;

      formValues[index][name] = value;

      if (name === "termsAmount" && totalnet) {
        formValues[index]["termsPersent"] = parseFloat(
          (parseFloat(
            formValues[index]["termsAmount"]?.toString()?.replaceAll(",", ""),
          ) /
            totalnet) *
          100,
        );
      } else if (name === "termsPersent" && totalnet) {
        formValues[index]["termsAmount"] = parseFloat(
          (parseFloat(formValues[index]["termsPersent"]) / 100) * totalnet,
        );
      }
    }
    setTerms({
      ...terms,
      formValues,
    });
  };
  const inputEvent3 = (e, index, pName) => {
    let formValues = commission.formValues;

    if (pName) {
      console.log(e);
      if (pName === "commissionParty") {
        console.log("formValues", formValues[index]);
        formValues[index]["commissionParty"] = e;
      }
    } else {
      const value = e.target.value;
      const name = e.target.name;
      console.log("--------------------=", name, value);
      let totalnet = totalValues.totalCost?.toString()?.replaceAll(",", "");
      totalnet = parseFloat(totalnet) > 0 ? parseFloat(totalnet) : 0;

      formValues[index][name] = value;

      if (name === "commissionAmount" && totalnet) {
        formValues[index]["commissionPersent"] = parseFloat(
          (parseFloat(
            formValues[index]["commissionAmount"]
              ?.toString()
              ?.replaceAll(",", ""),
          ) /
            totalnet) *
          100,
        );
      } else if (name === "commissionPersent" && totalnet) {
        formValues[index]["commissionAmount"] = parseFloat(
          (parseFloat(formValues[index]["commissionPersent"]) / 100) * totalnet,
        );
      }
    }
    setCommission({
      ...commission,
      formValues,
    });
  };
  const propTypeLov = () => {
    axios
      .post(
        `${baseurl}/realEState/getPropType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setPropTypLov({
          ...propTypLov,
          propTypLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propCatLov = () => {
    axios
      .post(
        `${baseurl}/realEState/getPropCat`,
        {
          companyId: companyId,
          username: username,
          // brId: this.props?.location.state?.row_branch_id,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((res) => {
        let responseData = res.data.data;

        setCategoryLov({
          ...categoryLov,
          categoryLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propSectLov = (id) => {
    axios
      .post(
        `${baseurl}/RealEstate/getSector`,
        {
          companyId: companyId,
          username: username,
          id,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((res) => {
        let responseData = res.data.data;
        setSectorLov({
          ...sectorLov,
          sectorOptions: responseData,
        });
        // setMasterData({ ...masterData, sectorId: null });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propsocitLov = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getAllSocietyLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setSocietyLov({
          ...societyLov,
          societyLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPartys = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getParty`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setPartyLov({
          ...partyLov,
          partyLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTermsTypes = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getTermsType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setTermsTypeLov({
          ...termsTypeLov,
          termsTypeOptions: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPeriods = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getPeriod`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setPeriodsLov({
          ...periodsLov,
          periodsOptions: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const propSizLov = () => {
    axios
      .post(
        `${baseurl}/RealEstate/getPropertSizeMtLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;
        setPropSizeLov({
          ...propSizeLov,
          propSizeLov: responseData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChangeMapHideShow = (e) => {
    setDivcontainer(!divcontainer);
  };
  const handleChangeMapHideShow2 = (e) => {
    setDivcontainer2(!divcontainer2);
  };
  const handleChangeMapHideShow3 = (e) => {
    setDivcontainer3(!divcontainer3);
  };
  let propsData = props.location.state;
  const getIpCountry = async () => {
    let { userIp, userCountry } = await getUserIp();
    setIpCountry({ userIp, userCountry });
  };
  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
    };
    let id = propsData?.id;
    if (propsData?.updateCheck === 1 || propsData?.updateCheck === 2) {
      if (propsData?.updateCheck === 1) {
        funCall(0);
      } else {
        funCall(2);
      }
      getDataWithId(id, propsData?.updateCheck);
    } else {
      funCall(1);
      // dealMaxNumber();
      checkDateOfYear(data.depDate);
    }
    if (propsData?.updateCheck !== 1) {
    propCatLov();
    propsocitLov();
    propTypeLov();
    propSizLov();
    getPartys();
    getTermsTypes();
    getPeriods();
    getInstallmentWizards();
    }

    if (propsData?.updateCheck !== 1) getIpCountry();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/propertyPurchase";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };


  const getInstallmentWizards = () => {
    setLoadingResponce(true);

    axios
      .post(
        `${baseurl}/RealEstate/getInstallmentWizards`,
        { companyId: companyId, username: username },
        {
          headers: { authorization: token },
        }
      )
      .then((response) => {
        const uniqueArr = Array.from(
          new Map(response.data.data.map((item) => [item.id, item])).values()
        );

        setMainInstallmentArray(response.data.data);
        setInstallmentWizardOption(uniqueArr);
        setLoadingResponce(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingResponce(false);
      });
  };
  const installmentHandleChange = (e) => {
    if (e?.id) {
      const startDate = moment(masterData.purchaseDate).format("YYYY-MM-DD");

      const resultFilter = mainInstallmentArray.filter(
        (item) => item.id === e.id
      );

      // Separate Possession
      const possessionTerm = resultFilter.find(
        (t) => t.term_type_desc === "Possession"
      );

      let others = resultFilter
        .filter((t) => t.term_type_desc !== "Possession")
        .sort((a, b) => a.seq_no - b.seq_no);

      let trackers = others.map((t) => ({
        ...t,
        current: 1,
        lastDate: startDate,
      }));

      let result = [];
      let usedDates = new Set();

      // ---- Advance first ----
      let advance = trackers.find((t) => t.term_type_desc === "Advance");

      if (advance) {
        const d = new Date(formatDate(startDate));

        result.push({
          term_type_desc: "Advance-1",
          paymentDate: d,
          seq_no: advance.seq_no,
          termsAmount: (totalValues.totalCost * advance.percent) / 100,
          termsPersent: advance.percent,
          termsType: {
            id: advance.term_type_id,
            value: advance.term_type_id,
            label: advance.term_type_desc,
          },
        });

        usedDates.add(formatDate(d));
        advance.current++;
        advance.lastDate = startDate;
      }

      trackers = trackers.filter((t) => t.term_type_desc !== "Advance");

      // ---- Round Robin generation ----
      let active = true;

      while (active) {
        active = false;

        for (let t of trackers) {
          if (t.current <= t.no_of_inst) {
            active = true;

            let nextDate = addMonths(t.lastDate, t.months);

            while (usedDates.has(formatDate(nextDate))) {
              nextDate = addMonths(nextDate, 1);
            }

            const finalDate = formatDate(nextDate);

            result.push({
              term_type_desc: `${t.term_type_desc}-${t.current}`,
              paymentDate: new Date(finalDate),
              seq_no: t.seq_no,
              termsAmount: (totalValues.totalCost * t.percent) / 100,
              termsPersent: t.percent,
              termsType: {
                id: t.term_type_id,
                value: t.term_type_id,
                label: t.term_type_desc,
              },
            });

            usedDates.add(finalDate);
            t.lastDate = nextDate;
            t.current++;
          }
        }
      }

      // ---- Sort by date ----
      result.sort(
        (a, b) => new Date(a.paymentDate) - new Date(b.paymentDate)
      );

      // ---- Add Possession at END ----
      if (possessionTerm && result.length > 0) {
        let lastDate = new Date(result[result.length - 1].paymentDate);
        let possessionDate = addMonths(lastDate, 1);

        result.push({
          term_type_desc: "Possession-1",
          paymentDate: new Date(formatDate(possessionDate)),
          seq_no: possessionTerm.seq_no,
          termsAmount:
            (totalValues.totalCost * possessionTerm.percent) / 100,
          termsPersent: possessionTerm.percent,
          termsType: {
            id: possessionTerm.term_type_id,
            value: possessionTerm.term_type_id,
            label: possessionTerm.term_type_desc,
          },
        });
      }

      reCalculate(result);
      setTerms({
        ...terms,
        formValues: result,
      });

    }

    setInstallmentWizard(e);
  };
  const checkDateOfYear = async (e) => {
    let purchaseDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      purchaseDate = masterData.purchaseDate;
    } else {
      byDefault = "";
      purchaseDate = e;
    }
    const tableName = "re_deals_mt";
    const invoiceType = "";
    const invBookId = 36;
    const dateColumn = "deal_date";
    const documentNo = "deal_no";
    var date = moment(masterData.purchaseDate).format("YYYY-MM-DD");

    let closeDate = await CheckClosingYearD(
      date,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault,
    );
    let purchaseNo = closeDate[1];

    if (closeDate[0] === true) {
      setMasterData({
        ...masterData,
        purchaseDate: "",
        purchaseNo: "",
      });
    } else if (closeDate[0] === false) {
      setMasterData({
        ...masterData,
        purchaseDate: masterData.purchaseDate,
        purchaseNo: purchaseNo,
      });
    } else {
      setMasterData({
        ...masterData,
        purchaseDate: "",
        purchaseNo: "",
      });
    }
  };
  const getDataWithId = (id, updateCheck) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/realEState/getPurchaseDealWithId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((res) => {
        let response = res.data.data;
        let resDataMt = response.masterRecord[0];
        let resDataDet = response.masterRecord;
        let termsRecord = response.termsRecord;
        let commissionRecord = response.commRecord;

        // 0 = add, 1 = disabled, 2 = update
        if (updateCheck === 1) {
          setDisabledState(true);
        }

        const {
          deal_no,
          deal_comp_id,
          deal_date,
          deal_desc,
          company_name,
          society_id,
          society_name,
          sector_id,
          sector_name,
          Owmer_name,
          cell_no,
          Address_det,
          nic_no,
          remarks,
          id,
          journal_id,
        } = resDataMt;
        let prop_deal_date = convertToYmdDateFormart(deal_date, 1);

        setMasterData({
          ...masterData,
          purchaseNo: deal_no,
          purchaseDate: prop_deal_date,
          partyName: checkNullObject(deal_comp_id, company_name),
          purchaseDescription: deal_desc,
          societyId: checkNullObject(society_id, society_name),
          sectorId: checkNullObject(sector_id, sector_name),
          ownerName: Owmer_name,
          ownerAddress: Address_det,
          ownerPhone: cell_no,
          ownerNic: nic_no,
          journalId: journal_id,
          remarks: remarks,
          updateCheck,
          id,
        });
        if (society_id && updateCheck !== 1) propSectLov(society_id);

        let formValues = [];
        for (let index = 0; index < resDataDet.length; index++) {
          const {
            unit_no,
            prop_type_id,
            prop_type_name,
            prop_catag_id,
            prop_catag_name,
            prop_size_id,
            prop_size_desc,
            all_id,
            factor_ids,
            detRemarks,
            comp_price,
            commission,
          } = resDataDet[index];
          let checkboxes = all_id;
          let checkboxesArray = "[";
          checkboxesArray = checkboxesArray + checkboxes + "]";
          checkboxesArray = checkboxesArray.replace(/'\'/g, "");
          checkboxesArray = JSON.parse(checkboxesArray);
          let featurelabels = all_id;
          let featurelabelsArray = "[";
          featurelabelsArray = featurelabelsArray + featurelabels + "]";
          featurelabelsArray = featurelabelsArray.replace(/'\'/g, "");
          console.log("featurelabelsArray :>> ", featurelabelsArray);
          // return
          featurelabelsArray = JSON.parse(featurelabelsArray);
          formValues.push({
            unitNo: unit_no,
            type: checkNullObject(prop_type_id, prop_type_name),
            category: checkNullObject(prop_catag_id, prop_catag_name),
            size: checkNullObject(prop_size_id, prop_size_desc),
            companyPrice: comp_price,
            commission,
            checkboxes: checkboxesArray,
            remarks: detRemarks,
            totalCost: comp_price + commission,
          });
        }
        reCalculate(formValues);
        setData({ ...data, formValues: formValues });

        let termsFormValues = [];
        for (let index = 0; index < termsRecord.length; index++) {
          const {
            term_type_id,
            term_type_desc,
            amount,
            perc,
            PERIOD_TYPE_ID,
            PERIOD_TYPE_DESC,
            no_of_periods,
            remarks,
            payment_date
          } = termsRecord[index];
          termsFormValues.push({
            termsType: checkNullObject(term_type_id, term_type_desc),
            termsAmount: amount,
            termsPersent: perc,
            termsPeriod: checkNullObject(PERIOD_TYPE_ID, PERIOD_TYPE_DESC),
            termsNo: no_of_periods,
            termsRemarks: remarks,
            paymentDate: convertToYmdDateFormart(payment_date, 1)
          });
        }
        setTerms({ ...terms, formValues: termsFormValues });

        let commisionFormValues = [];
        console.log("commissionRecord===>", commissionRecord);
        if (commissionRecord.length > 0) {
          for (let index = 0; index < commissionRecord.length; index++) {
            const { party_id, Party_Name, comm_amt, comm_perc, remarks } =
              commissionRecord[index];
            commisionFormValues.push({
              commissionParty: checkNullObject(party_id, Party_Name),
              commissionAmount: comm_amt,
              commissionPersent: comm_perc,
              commissionRemarks: remarks,
            });
          }
          console.log("bbbbbbbbbbbbb");
          setCommission({ ...commission, formValues: commisionFormValues });
        } else {
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaa");
          setCommission({ ...commission, formValues: [{}] });
        }
        setLoadingResponce(false);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        // setLoadingResponce(false);
      });
  };
  ////////////////-----Toggle For Model ------////////////////////
  const addPartyToggle = () => {
    setMasterData({
      ...masterData,
      isOpenPartyModel: !masterData.isOpenPartyModel,
    });
    getPartys();
  };
  const addSocietyToggle = () => {
    setMasterData({
      ...masterData,
      isOpenSocietyModel: !masterData.isOpenSocietyModel,
    });
    propsocitLov();
  };
  const addSectorToggle = () => {
    setMasterData({
      ...masterData,
      isOpenSectorModel: !masterData.isOpenSectorModel,
    });
    propSectLov();
  };
  const dealMaxNumber = () => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/realEState/getDealMaxNo`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((res) => {
        let response = res.data.data[0];
        let purchaseNo = response?.max_deal_no;
        setMasterData({ ...masterData, purchaseNo });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };
  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const handleSubmit = async (event) => {
    console.log("submit", masterData, data, terms, commission);
    setLoadingResponce(true);

    event.preventDefault();

    var companyId = localStorage.getItem("companyId");

    // let { userIp, userCountry } = await ipCountry();
    let { userIp, userCountry } = await getUserIp;

    let partyId = masterData?.partyName?.id;
    let societyId = masterData?.societyId?.id;
    let sectorId = masterData?.sectorId?.id;
    let validateCheck = true;
    let sumOfPersent = 0;
    console.log("pehlaaaaaaaaaaaa", sumOfPersent);
    let termsPercentageExceed = 0;
    // 0 ka mtlb he terms and commission 2no show na ho
    // 1 k mtlb he terms on he
    // 2 ka mtlb he commission on he

    // let midManId = masterData?.midManId?.id ? masterData?.midManId?.id : null;

    let checkRequired = true;
    for (let index = 0; index < data.formValues.length; index++) {
      const element = data.formValues[index];
      if (!element?.type?.id || !element?.category?.id || !element?.size?.id) {
        checkRequired = false;
        break;
      }
    }
    // if (
    //   terms.formValues?.[0]?.["termsType"]?.id ||
    //   terms.formValues?.[0]?.["termsPeriod"]?.id
    // ) {
    //   for (let index = 0; index < terms.formValues.length; index++) {
    //     const element = terms.formValues[index];
    //     if (!element?.termsType?.id || !element?.termsPeriod?.id) {
    //       checkRequired = false;
    //       break;
    //     }
    //   }
    // }

    if (
      commission.formValues?.[0]?.["commissionParty"]?.id ||
      commission.formValues?.[0]?.["commissionAmount"] ||
      commission.formValues?.[0]?.["commissionPersent"] ||
      commission.formValues?.[0]?.["commissionRemarks"]
    ) {
      for (let index = 0; index < commission.formValues.length; index++) {
        const element = commission.formValues[index];
        if (!element?.commissionParty?.id) {
          checkRequired = false;
          break;
        }
      }
    }
    console.log(
      "Idddddddddddddds",
      partyId,
      societyId,
      sectorId,
      checkRequired,
    );
    if (checkRequired) {
      // const terms = terms.formValues;
      for (let i = 0; i < terms.formValues.length; i++) {
        sumOfPersent += Number(
          terms.formValues[i]?.termsPersent?.toString()?.replaceAll(",", ""),
        );
        console.log("sumOfPersent :>> ", sumOfPersent, sumOfPersent > 100);
        if (sumOfPersent > 100) {
          validateCheck = false;
          checkRequired = false;
          termsPercentageExceed = 1;

          break;
        }
      }
    }
    if (checkRequired) {
      sumOfPersent = 0;
      // let formValues = commission.formValues;
      for (let i = 0; i < commission.formValues.length; i++) {
        sumOfPersent += Number(
          commission.formValues[i]?.commissionPersent
            ?.toString()
            ?.replaceAll(",", ""),
        );
        console.log("sumOfPersent :>> ", sumOfPersent, sumOfPersent > 100);
        if (sumOfPersent > 100) {
          termsPercentageExceed = 2;
          validateCheck = false;
          break;
        }
      }
    }

    if (validateCheck && partyId && societyId && sectorId && checkRequired) {
      let purchaseDate = convertToYmdDateFormart(masterData.purchaseDate);
      // let targetDate = convertToYmdDateFormart(masterData.targetDate);
      // return;
      if (masterData.id > 0) {
        axios
          .post(
            `${baseurl}/realEState/updatepropPurchase`,
            {
              id: masterData?.id,
              companyId,
              purchse_No: masterData.purchaseNo,
              purchase_date: purchaseDate,
              party_Name: partyId,
              purchase_Description: masterData.purchaseDescription,
              society_Id: societyId,
              sector_Id: sectorId,
              owner_Name: masterData.ownerName,
              owner_Address: masterData.ownerAddress,
              owner_Phone: masterData.ownerPhone,
              owner_Nic: masterData.ownerNic,
              mast_Remarks: masterData.remarks ? masterData.remarks : "",
              detailArray: data.formValues,
              termsArray: terms.formValues,
              commissionArray: commission.formValues,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            },
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Purchase Updated",
                icon: "success",
              }).then((value) => {
                // toggleAddNew();
                setMasterData({
                  ...masterData,
                  showJvBtn: true,
                });
                setDisabledState(true);
                // props.history.push({
                //   pathname: "/DealOverview",
                // });
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          })
          .finally(function () {
            setLoadingResponce(false);
          });
      } else {
        axios
          .post(
            `${baseurl}/realEState/addPurchaseDeal`,
            {
              companyId,
              purchse_No: masterData.purchaseNo,
              purchase_date: purchaseDate,
              party_Name: partyId,
              purchase_Description: masterData.purchaseDescription,
              society_Id: societyId,
              sector_Id: sectorId,
              owner_Name: masterData.ownerName,
              owner_Address: masterData.ownerAddress,
              owner_Phone: masterData.ownerPhone,
              owner_Nic: masterData.ownerNic,
              mast_Remarks: masterData.remarks ? masterData.remarks : "",
              detailArray: data.formValues,
              termsArray: terms.formValues,
              commissionArray: commission.formValues,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            },
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Purchase Added",
                icon: "success",
              }).then((value) => {
                setMasterData({
                  ...masterData,
                  purchaseNo: response.data.latestDocNo,
                  journalId: response.data.journalId,
                  id: response.data?.id,
                  showJvBtn: true,
                });
                setDisabledState(true);
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            // setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          })
          .finally(function () {
            setLoadingResponce(false);
          });
      }
      if (!commission.formValues?.[0]?.commissionParty?.id)
        setDivcontainer2(false);
    } else {
      console.log("sumOfPersent11111", sumOfPersent);
      sumOfPersent > 0
        ? swal({
          title: "!Percentage exceed",
          text: `The ${termsPercentageExceed === 1
            ? "Terms"
            : termsPercentageExceed === 2
              ? "Commission"
              : 0
            }  percentage cannot exceed 100%.`,
          icon: "error",
        })
        : swal({
          title: "Invalid Entry",
          text: "Please enter all required fields",
          icon: "warning",
        });
      sumOfPersent = 0;
      termsPercentageExceed = 0;
      console.log("sumOfPersent2222222222222", sumOfPersent);

      setRequiredCheck(true);
      setLoadingResponce(false);
    }
  };
  const { isOpenPartyModel, isOpenSectorModel, isOpenSocietyModel } =
    masterData;
  const { formValues } = data;
  return (
    <>
      {loadingResponce === true ? (
        <ResponseLoader />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>
                    Property Purchase Form
                    {propsData?.updateCheck === 1
                      ? " - (preview)"
                      : propsData?.updateCheck === 2
                        ? " - (Update)"
                        : " - (Add)"}
                  </h4>
                </strong>
              </>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  to="/propertyPurchaseOverview"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>

          <Row className="rowStyling">
            <Col>
              <div className="row">
                <div className="col-md-12">
                  <Form name="simpleForm" onSubmit={handleSubmit}>
                    <div className="row">
                      {/* <div className="col-md-12">
                          <div className="row my-2" translate="no"></div>
                        </div> */}
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Purchase No:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="purchaseNo"
                          id="purchaseNo"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.purchaseNo}
                          required
                          disabled
                        />
                      </div>
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      ></div>
                      <ReactDatePicker
                        label="Purchase Date:"
                        className="col-xl-3"
                        isSelected={masterData.purchaseDate}
                        onChange={(e) => {
                          setMasterData({
                            ...masterData,
                            purchaseDate: e,
                            // targetDate: null,
                          });
                        }}
                        isDisabled={disabledState}
                      />
                      <div className="col-md-4 col-lg-5">
                        <Label>
                          Party Name:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={partyLov.partyLov}
                          onChange={(e) => {
                            masterInputEvent(e, "partyName");
                            // await checkDuplicatePartySelection();
                          }}
                          value={masterData.partyName}
                          required
                          id="partyName"
                          name="partyName"
                          isClearable
                          placeholder={"-- Select --"}
                          isDisabled={disabledState}
                        />

                        {!masterData.partyName?.id && requiredCheck ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Company Name</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-2 col-lg-1 mt-4 pt-1">
                        <button
                          className="btn-client-invoice "
                          style={{
                            width: "90px",
                          }}
                          size="sm"
                          type="button"
                          onClick={addPartyToggle}
                          disabled={disabledState}
                        >
                          Add Party
                        </button>
                      </div>

                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Purchase Description:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="purchaseDescription"
                          id="purchaseDescription"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.purchaseDescription}
                          required
                          disabled={disabledState}
                        />
                      </div>
                      <div className="col-md-4 col-lg-5">
                        <Label style={{ fontWeight: "bold" }}>
                          Society:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={societyLov.societyLov}
                          onChange={(e) => masterInputEvent(e, "societyId")}
                          value={masterData.societyId}
                          required
                          id="societyId"
                          name="societyId"
                          isClearable
                          placeholder={"-- Select --"}
                          isDisabled={disabledState}
                        />

                        {!masterData.societyId?.id && requiredCheck ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Society</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-2 col-lg-1 mt-4 pt-1">
                        <button
                          className="btn-client-invoice "
                          style={{
                            width: "90px",
                          }}
                          size="sm"
                          type="button"
                          onClick={addSocietyToggle}
                          disabled={disabledState}
                        >
                          Add Society
                        </button>
                      </div>
                      <div className="col-md-4 col-lg-5">
                        <Label style={{ fontWeight: "bold" }}>
                          Sector/Phase:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={sectorLov.sectorOptions}
                          onChange={(e) => masterInputEvent(e, "sectorId")}
                          value={masterData.sectorId}
                          required
                          isDisabled={
                            !masterData.societyId?.id || disabledState
                          }
                          id="sectorId"
                          name="sectorId"
                          isClearable
                          placeholder={"-- Select --"}
                        />

                        {!masterData.sectorId?.id && requiredCheck ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Sector/Phase</p>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-2 col-lg-1 mt-4 pt-1">
                        <button
                          className="btn-client-invoice "
                          style={{
                            width: "90px",
                          }}
                          size="sm"
                          type="button"
                          onClick={addSectorToggle}
                          disabled={disabledState}
                        >
                          Add Sector
                        </button>
                      </div>

                      <div
                        className="col-md-12"
                        style={{ marginBottom: "12px", textAlign: "center" }}
                      >
                        {" "}
                        <h4>Owner Details</h4>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ marginBottom: "12px" }}
                      >
                        <div
                          className="row"
                          style={{
                            // paddingLeft: "2px",
                            backgroundColor: "#ECEEFF",
                            borderRadius: "23px",
                          }}
                        >
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Name:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerName"
                              id="ownerName"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerName}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Address:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerAddress"
                              id="ownerAddress"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerAddress}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Phone:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerPhone"
                              id="ownerPhone"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerPhone}
                              required
                              disabled={disabledState}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              NIC No:
                              <span style={{ color: "tomato" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="ownerNic"
                              id="ownerNic"
                              onChange={(e) => masterInputEvent(e)}
                              value={masterData.ownerNic}
                              required
                              disabled={disabledState}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>Remarks:</Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="remarks"
                          id="remarks"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.remarks || ""}
                          disabled={disabledState}
                        />
                      </div>

                      <div className="col-md-12 lableDivStyling">
                        <Row className="pt-1">
                          <Col xs="6">
                            <>
                              <span style={{ fontWeight: "bold" }}>
                                Total Properties
                              </span>
                            </>
                          </Col>
                          <Col xs="6">
                            <div
                              style={{
                                textAlign: "right",
                              }}
                            >
                              <AppSwitch
                                className={"mx-1"}
                                onClick={handleChangeMapHideShow}
                                variant="pill"
                                color="primary"
                                label
                                checked={divcontainer}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {divcontainer ? (
                        <div className="col-md-12 mb-2">
                          {data.formValues.map((element, index) => (
                            <div className="div my-1">
                              <div className="InvoiceLine-styling ">
                                {/* <div className="col-md-4 col-lg-4 col-xl-3  InvoiceLineHeading">
                                  <h6>
                                    Contact Person Details # {element.lineNum}{" "}
                                  </h6>
                                </div> */}
                                <div class="row">
                                  <div className="col-md-3  ">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Unit No:
                                      <h8 style={{ color: "tomato" }}>*</h8>
                                    </Label>

                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="unitNo"
                                      id="unitNo"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.unitNo}
                                      required
                                      disabled={disabledState}
                                    />
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Type:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Select
                                      // key={JSON.stringify(element.itemType)}
                                      value={element.type}
                                      onChange={(e) =>
                                        inputEvent(e, index, "type")
                                      }
                                      options={propTypLov.propTypLov}
                                      id="type"
                                      name="type"
                                      isClearable
                                      placeholder={"-- Select --"}
                                      isDisabled={disabledState}
                                    />

                                    {requiredCheck && !element.type?.id ? (
                                      <div style={{ color: "red" }}>
                                        <p>Please Select Property Type</p>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Category:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Select
                                      // key={JSON.stringify(element.itemType)}
                                      value={element.category}
                                      onChange={(e) =>
                                        inputEvent(e, index, "category")
                                      }
                                      options={categoryLov.categoryLov}
                                      id="category"
                                      name="category"
                                      isClearable
                                      placeholder={"-- Select --"}
                                      isDisabled={disabledState}
                                    />

                                    {requiredCheck && !element.category?.id ? (
                                      <div style={{ color: "red" }}>
                                        <p>Please Select Property Category</p>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Size:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Select
                                      // key={JSON.stringify(element.itemType)}
                                      value={element.size}
                                      onChange={(e) =>
                                        inputEvent(e, index, "size")
                                      }
                                      options={propSizeLov.propSizeLov}
                                      id="size"
                                      name="size"
                                      isClearable
                                      placeholder={"-- Select --"}
                                      isDisabled={disabledState}
                                    />

                                    {requiredCheck && !element.size?.id ? (
                                      <div style={{ color: "red" }}>
                                        <p>Please Select Property Size</p>
                                      </div>
                                    ) : null}
                                  </div>

                                  <div className="col-md-3">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Total Cost:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>
                                    <NumberFormat
                                      name="companyPrice"
                                      id="companyPrice"
                                      className="form-control"
                                      style={{ textAlign: "right" }}
                                      thousandSeparator={true}
                                      value={element.companyPrice || ""}
                                      decimalScale={0}
                                      fixedDecimalScale
                                      // placeholder="0.00"
                                      allowNegative={false}
                                      // isNumericString
                                      // onChange={(e) => inputEvent(e, index)}
                                      onChange={(e) => {
                                        if (
                                          !terms.formValues[0]?.termsAmount &&
                                          !commission.formValues[0]
                                            ?.commissionAmount &&
                                          terms.formValues?.length === 1 &&
                                          commission.formValues?.length === 1
                                        ) {
                                          inputEvent(e, index);
                                        } else {
                                          swal({
                                            icon: "warning",
                                            label: "Invalid Operation",
                                            text: "First delete the Terms and Commission data!",
                                          });
                                        }
                                      }}
                                      required
                                      disabled={disabledState}
                                    />
                                  </div>
                                  <div className="col-md-3 pt-4 mt-1">
                                    <div>
                                      <Button
                                        type="button"
                                        size="sm"
                                        className="btn btn-danger mx-2"
                                        onClick={() => {
                                          showProp(element, index);
                                        }}
                                        // disabled={disabledState}
                                        title={dynamicCurrencyFormator({
                                          cell: element.totalCost,
                                          field: 1,
                                        })}
                                      // disabled={disabled ? true : false }
                                      >
                                        Info
                                      </Button>
                                      <Button
                                        className="btn btn-info text-white mx-2"
                                        type="button"
                                        size="sm"
                                        onClick={() =>
                                          addFormFieldsItem(1, index)
                                        }
                                        disabled={disabledState}
                                        title="Add new row with record"
                                      // title={tooltipText.addMulLineInv}
                                      >
                                        <i className="fa fa-copy"></i>
                                      </Button>
                                      <Button
                                        className="btn btn-info text-white mx-2"
                                        type="button"
                                        size="sm"
                                        onClick={() => addFormFieldsItem()}
                                        title="Add new row"
                                        disabled={disabledState}

                                      // title={tooltipText.addMulLineInv}
                                      >
                                        <i className="fa fa-plus"></i>
                                      </Button>

                                      <Button
                                        type="button"
                                        size="sm"
                                        className="btn btn-danger mx-2"
                                        onClick={() =>
                                          removeFormFieldsItem(index)
                                        }
                                        disabled={disabledState}
                                        title={tooltipText.remMulLineInv}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </Button>
                                    </div>
                                  </div>
                                  <div className="col-md-3 pt-4 mt-1 ">
                                    {element?.checkboxes?.map((checkbox) => (
                                      <span
                                        className={`btn btn-sm btn-${checkbox?.color} mx-1 rounded-pill `}
                                      >
                                        {checkbox?.shortDesc}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="row mt-4">
                            <div className="card-header-Creative-Invoice-Totals col-md-2 col-lg-1 mt-n3 ml-3">
                              <strong>
                                <h5>Total</h5>
                              </strong>
                            </div>
                          </div>

                          <div className="div" style={{ marginTop: "7px" }}>
                            <div className="row">
                              <div className="col-md-3">
                                <Label style={{ fontWeight: "bold" }}>
                                  {" "}
                                  Total Cost
                                </Label>

                                <NumberFormat
                                  name="totalCost"
                                  className="form-control"
                                  disabled
                                  thousandSeparator={true}
                                  value={totalValues.totalCost || "0"}
                                  decimalScale={0}
                                  fixedDecimalScale={true}
                                // defaultValue="0.00"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {/* <div className="col-md-12 border-bottom my-2">
                          <h3>Terms </h3>
                        </div> */}
                      <div className="col-md-12 border-bottom my-2">
                        <Row className="pt-1">
                          <Col xs="2">
                            <>
                              <h3>Terms </h3>
                            </>
                          </Col>
                          <Col xs="4">

                            <Select
                              value={installmentWizard || ""}
                              onChange={installmentHandleChange}
                              options={installmentWizardOption}
                              name="installmentWizard"
                              placeholder="-- Select --"
                              isDisabled={disabledState}
                            />
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-1"
                              size="sm"
                              title="View Plan"
                              disabled={!installmentWizard?.id}
                              style={{ cursor: "pointer" }}
                              onClick={() => addPropInstall(true)}
                            >
                              <i className="fa fa-eye"></i>
                            </Button>
                            <Button
                              className="m-1"
                              size="sm"
                              color="danger"
                              title="Clear All Terms"
                              disabled={disabledState || terms.formValues.length === 0}
                              onClick={removeAllTerms}
                            >
                              <i className="fa fa-refresh"></i> Reset
                            </Button>

                          </Col>
                          <Col xs="2"
                          >
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled={disabledState ? true : false}
                              onClick={() => addPropInstall(false)} // modal open function
                            >
                              Installment Wizard +
                            </button>
                          </Col>
                          <Col xs="2">
                            <div
                              style={{
                                textAlign: "right",
                              }}
                            >
                              <AppSwitch
                                className={"mx-1"}
                                onClick={handleChangeMapHideShow3}
                                variant="pill"
                                color="primary"
                                label
                                checked={divcontainer3}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="row mx-2 my-3 p-2 InfoBox  ">
                        {divcontainer3 ? (
                          <>
                            <div className="div my-1">
                              <div className="row pl-3">
                                <div className="col-md-1">
                                  <Label>
                                    Install.No:
                                    <span className="text-danger">*</span>
                                  </Label>
                                </div>
                                <div className="col-md-2  ">
                                  <Label>
                                    Type :
                                    <span className="text-danger">*</span>
                                  </Label>
                                </div>

                                <div className="col-md-2">
                                  <Label>
                                    Amount :
                                    <span className="text-danger">*</span>
                                  </Label>
                                </div>
                                <div className="col-md-2 col-lg-1">
                                  <Label>
                                    %:{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                </div>




                                <div className="col-md-2">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Payment Date:
                                  </Label>
                                </div>
                                <div className="col-md-3">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Remarks:
                                  </Label>
                                </div>
                              </div>
                              {terms.formValues.map((element, index) => (
                                <div className=" " key={index}>
                                  <div className="row pl-3">
                                    <div className="col-md-1">
                                      <NumberFormat
                                        name="installmentNo"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        thousandSeparator={true}
                                        value={index + 1 || ""}
                                        placeholder="00"
                                        decimalScale={0}
                                        required
                                        fixedDecimalScale
                                        disabled
                                      />
                                    </div>
                                    <div className="col-md-2  ">
                                      <Select
                                        value={element.termsType || ""}
                                        onChange={(e) =>
                                          inputEvent2(e, index, "termsType")
                                        }
                                        options={termsTypeLov.termsTypeOptions}
                                        // autoFocus
                                        isClearable
                                        required
                                        name="termsType"
                                        placeholder={"-- Select --"}
                                        isDisabled={disabledState}
                                      />
                                      {requiredCheck &&
                                        !element.termsType?.id && (
                                          <span className="text-danger">
                                            <p>Please Select Type</p>
                                          </span>
                                        )}
                                    </div>

                                    <div className="col-md-2">

                                      <NumberFormat
                                        name="termsAmount"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        thousandSeparator={true}
                                        value={element.termsAmount || ""}
                                        placeholder="00"
                                        decimalScale={0}
                                        required
                                        fixedDecimalScale
                                        onChange={(e) => inputEvent2(e, index)}
                                        disabled={disabledState}
                                      />
                                      <span style={{ color: "Red" }}>
                                        {element.termsAmountError}
                                      </span>
                                    </div>
                                    <div className="col-md-2 col-lg-1">
                                      <NumberFormat
                                        name="termsPersent"
                                        style={{ textAlign: "right" }}
                                        className="form-control"
                                        value={element.termsPersent || ""}
                                        disabled={disabledState}
                                        required
                                        fixedDecimalScale
                                        decimalScale={2}
                                        placeholder="0.00"
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                      <br />
                                      <span style={{ color: "Red" }}>
                                        {element.termsPersentError}
                                      </span>
                                    </div>
                                    {/* <div className="col-md-3 col-lg-2">
                                      <Label>
                                        Period:{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Select
                                        value={element.termsPeriod || ""}
                                        onChange={(e) =>
                                          inputEvent2(e, index, "termsPeriod")
                                        }
                                        options={periodsLov.periodsOptions}
                                        // autoFocus
                                        isClearable
                                        isRequired={true}
                                        name="termsPeriod"
                                        placeholder={"-- Select --"}
                                        isDisabled={disabledState}
                                      />
                                      {requiredCheck &&
                                        !element.termsPeriod?.id && (
                                          <span className="text-danger">
                                            <p>Please Select Period</p>
                                          </span>
                                        )}
                                    </div>
                                    <div className="col-md-2 col-lg-1">
                                      <Label>
                                        No :{" "}
                                        <span className="text-danger">*</span>
                                      </Label>

                                      <Input
                                        name="termsNo"
                                        className="form-control"
                                        style={{ textAlign: "right" }}
                                        disabled={disabledState}
                                        value={element.termsNo || ""}
                                        placeholder="00"
                                        required
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                    </div> */}

                                    <ReactDatePicker
                                      // starick
                                      label=""
                                      className="col-md-2"
                                      isSelected={element.paymentDate}
                                      isDisabled={disabledState}
                                      onChange={(e) => inputEvent2(e, index, "paymentDate")}
                                    />

                                    <div className="col-md-3">
                                      <Input
                                        rows="1"
                                        type="textarea"
                                        id="termsRemarks"
                                        name="termsRemarks"
                                        // onKeyPress={(e) => {
                                        //   this.handleMessageBox(index, e, "terms");
                                        // }}
                                        className="form-control"
                                        disabled={disabledState}
                                        value={element.termsRemarks || ""}
                                        onChange={(e) => inputEvent2(e, index)}
                                      />
                                    </div>
                                    <div className="col-md-1 ml-n1 d-flex flex-row align-items-center">
                                      <>
                                        {/* <Button
                                          type="button"
                                          size="sm"
                                          className="btn btn-warning text-white text-bold "
                                          disabled={disabledState}
                                        >
                                          {element.termsTypeLineNum}S
                                        </Button> */}
                                        <Button
                                          className="btn btn-info text-white mx-2"
                                          type="button"
                                          size="sm"
                                          onClick={() => addTermsFormFields()}
                                          title="Add new row"
                                          disabled={disabledState}

                                        // title={tooltipText.addMulLineInv}
                                        >
                                          <i className="fa fa-plus "></i>
                                        </Button>

                                        <Button
                                          type="button"
                                          size="sm"
                                          className="btn btn-danger "
                                          onClick={() =>
                                            removeItemFormFields(index)
                                          }
                                          title="Delete row"
                                          disabled={disabledState}
                                        >
                                          <i className="fa fa-trash "></i>
                                        </Button>
                                      </>
                                    </div>
                                  </div>
                                  {terms.formValues.length > 1 ? (
                                    <hr style={{}} />
                                  ) : null}
                                </div>
                              ))}
                            </div>
                          </>
                        ) : null}
                      </div>
                      <div className="col-md-12 InvoiceLine-styling">
                        <Row className="commissionLineHeading pt-2">
                          <Col xs="6">
                            <div className="text-left ">
                              <h5>Commission</h5>
                            </div>
                          </Col>
                          <Col xs="6" className="d-flex flex-row-reverse">
                            <AppSwitch
                              className="mx-1"
                              onClick={handleChangeMapHideShow2}
                              variant="pill"
                              // size="lg"
                              // disabled={this.state.disabled ? "disabled" : ""}
                              color="primary"
                              label
                              checked={divcontainer2}
                            />
                            {/* <p className=" mx-3 pt-1 ">
                              {" "}
                              {divcontainer2 ? "Hide " : "Show "}
                            </p> */}
                          </Col>
                        </Row>
                        <Collapse isOpen={true}>
                          {divcontainer2 ? (
                            <>
                              <div className="div my-1">
                                <div className="row" >
                                  <div className="col-md-3">
                                    <Label>
                                      Party:
                                      <span className="text-danger">*</span>
                                    </Label>
                                  </div>

                                  <div className="col-md-2">
                                    <Label>
                                      Amount :
                                      <span className="text-danger">*</span>
                                    </Label>
                                  </div>
                                  <div className="col-md-3 col-lg-2">
                                    <Label>
                                      %:{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                  </div>
                                  <div className="col-md-3">
                                    <Label>Remarks:</Label>
                                  </div>
                                </div>
                                {commission.formValues.map((element, index) => (
                                  <>
                                    <div className="row" key={index}>
                                      <div className="col-md-3">


                                        <Select
                                          value={element?.commissionParty || ""}
                                          onChange={(e) =>
                                            inputEvent3(
                                              e,
                                              index,
                                              "commissionParty",
                                            )
                                          }
                                          options={partyLov.partyLov}
                                          // autoFocus
                                          required
                                          isClearable
                                          name="commissionParty"
                                          placeholder={"-- Select --"}
                                          isDisabled={disabledState}
                                        />
                                        {!element.commissionParty?.id &&
                                          requiredCheck &&
                                          (element.commissionPersent ||
                                            element.commissionAmount ||
                                            element.commissionRemarks) ? (
                                          <div style={{ color: "red" }}>
                                            <p>Please Select Party</p>
                                          </div>
                                        ) : null}
                                      </div>

                                      <div className="col-md-2">


                                        <NumberFormat
                                          name="commissionAmount"
                                          className="form-control"
                                          style={{ textAlign: "right" }}
                                          thousandSeparator={true}
                                          value={element.commissionAmount || ""}
                                          placeholder="00"
                                          decimalScale={0}
                                          required={
                                            element.commissionParty?.id ||
                                            element.commissionPersent ||
                                            element.commissionRemarks
                                          }
                                          fixedDecimalScale
                                          onChange={(e) => inputEvent3(e, index)}
                                          disabled={disabledState}
                                        />
                                        <span style={{ color: "Red" }}>
                                          {element.qtyError}
                                        </span>
                                      </div>
                                      <div className="col-md-3 col-lg-2">


                                        <NumberFormat
                                          name="commissionPersent"
                                          style={{ textAlign: "right" }}
                                          className="form-control"
                                          value={element.commissionPersent || ""}
                                          disabled={disabledState}
                                          placeholder="0.00"
                                          fixedDecimalScale
                                          decimalScale={2}
                                          required={
                                            element.commissionParty?.id ||
                                            element.commissionAmount ||
                                            element.commissionRemarks
                                          }
                                          onChange={(e) => inputEvent3(e, index)}
                                        />
                                      </div>

                                      <div className="col-md-3">
                                        <Input
                                          rows="1"
                                          type="textarea"
                                          id="commissionRemarks"
                                          name="commissionRemarks"
                                          className="form-control"
                                          disabled={disabledState}
                                          value={element.commissionRemarks || ""}
                                          onChange={(e) => inputEvent3(e, index)}
                                        />
                                      </div>
                                      <div
                                        className="col-md-2"
                                        style={{ marginTop: "0px" }}
                                      >
                                        <Button
                                          className="btn btn-info text-white mx-2"
                                          type="button"
                                          size="sm"
                                          onClick={() => addFormFieldsItem2()}
                                          title="Add new row"
                                          disabled={disabledState}
                                        // title={tooltipText.addMulLineInv}
                                        >
                                          <i className="fa fa-plus "></i>
                                        </Button>

                                        <Button
                                          type="button"
                                          size="sm"
                                          className="btn btn-danger "
                                          onClick={() =>
                                            removeFormFieldsItem2(index)
                                          }
                                          title="Delete row"
                                          disabled={disabledState}
                                        >
                                          <i className="fa fa-trash "></i>
                                        </Button>
                                      </div>
                                    </div>
                                    {commission.formValues.length > 1 ? (
                                      <hr style={{}} />
                                    ) : null}
                                  </>
                                ))}
                              </div>
                            </>
                          ) : null}
                        </Collapse>
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup>
                      <span>
                        <span>
                          <Link
                            disabled={loadingResponce ? true : false}
                            className="btn btn-danger mr-1"
                            size="sm"
                            to={{
                              pathname: "/newManualJournal",
                              goBackUrl: "/propertyPurchase",
                              state: {
                                id: masterData?.journalId,
                                masterId: masterData?.id,
                                updateCheck: 1,
                                goBackLabel: "Property",
                              },
                            }}
                            hidden={
                              masterData?.showJvBtn
                                ? false
                                : !masterData.updateCheck ||
                                masterData.updateCheck == 2
                            }
                          // hidden={
                          //   !masterData.updateCheck || !masterData?.showJvBtn
                          // }
                          >
                            Show JV {masterData?.showJvBtn}
                          </Link>
                        </span>

                        {/* <Button
                          size="md"
                          color="success"
                          className={[
                            "invoiceSubmitButton",
                            props?.location?.state?.updateCheck
                              ? null
                              : "hideShowDiv",
                          ]}
                          hidden={
                            masterData?.showJvBtn
                              ? false
                              : masterData.updateCheck == 2
                          }
                          onClick={() => goBackFun()}
                        >
                          Print
                        </Button> */}

                        <span className="float-right">
                          <Link
                            to={{
                              pathname: "/propertyPurchaseOverview",
                            }}
                          >
                            <Button
                              disabled={
                                loadingResponce ? true : false || disabledState
                              }
                              className="mr-1"
                              size="sm"
                              hidden={masterData.updateCheck === 1}
                            >
                              Cancel
                            </Button>
                          </Link>
                          <Button
                            disabled={
                              loadingResponce ? true : false || disabledState
                            }
                            hidden={masterData.updateCheck === 1}
                            className="mr-1 invoiceSubmitButton "
                          >
                            {masterData.updateCheck === 2 ? "Update" : "Save"}{" "}
                            Changes
                          </Button>
                        </span>
                      </span>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          {/*......... Add Party modal Component call ..................... */}
          {isOpenPartyModel && (
            <>
              <Modal
                show={isOpenPartyModel}
                size="lg"
                onHide={addPartyToggle}
                backdrop="static"
              >
                <Modal.Body className=" mt-n4 px-1 mb-n3  ">
                  <AddPartyModel
                    closeModel={"closeModel"}
                    callBack={() => {
                      addPartyToggle();
                      getPartys();
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          )}
          {isOpenSocietyModel && (
            <>
              <AddSociety toggle={addSocietyToggle} />
            </>
          )}
          {isOpenInstallmentModal && (
            <InstallmentFeature
              toggle={addPropInstall}
              saleValue={totalValues.totalCost}
              view={view}
              mainInstallmentArray={mainInstallmentArray}
              installmentWizard={installmentWizard?.id}
            />
          )}

          {isOpenSectorModel && <AddSector toggle={addSectorToggle} />}
          <br></br>
          <br></br>

          {data.isOpenPropModel && (
            <>
              <Modal
                show={data.isOpenPropModel}
                size="lg"
                onHide={addPropToggle}
                backdrop="static"
              >
                <Modal.Header className=" Creative-Invoice-header-styling">
                  <h5> Property</h5>
                </Modal.Header>
                <Modal.Body className="">
                  <PropFeature
                    toggle={addPropToggle}
                    sendDataBack={{
                      checkboxes: formValues[checkIndex].checkboxes,
                      remarks: formValues[checkIndex].remarks,
                      id: formValues[checkIndex]?.dealPropId,
                      disableState: disabledState,
                    }}
                    callback={(e) => {
                      handleCheckBoxes(e, checkIndex);
                      addPropToggle();
                    }}
                  />
                </Modal.Body>
              </Modal>
            </>
          )}
        </div>
      )}
    </>
  );
}
